import src from "IMAGE";
export default { src, width: 1440, height: 459, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAAMElEQVR42n3JsQkAMAgF0T9D2kjAAZJRMpVzq4idoMVr7sB0Nb0iO/b5Ro14WCw6cb1HJSPXjE+LAAAAAElFTkSuQmCC", blurWidth: 8, blurHeight: 3 }
